const DR_PREFIX = /^(dr\.?|doctor|د\.?|دكتور)\s+/i;

/** Prepend "Dr. " unless the name already starts with a doctor prefix. */
export function formatDoctorName(name: string): string {
  const trimmed = name.trim();
  if (!trimmed) return trimmed;
  if (DR_PREFIX.test(trimmed)) return trimmed;
  return `Dr. ${trimmed}`;
}
